import * as actions from './actions';
import * as getters from './getters';
import {SET_TOGGLE_MOBILE_NAV, TOGGLE_MOBILE_NAV} from '../../mutation-types';


const mutations = {
  [TOGGLE_MOBILE_NAV](state) {
    state.toggleClass = !state.toggleClass
  },
  [SET_TOGGLE_MOBILE_NAV](state, payload) {
    state.toggleClass = payload
  },
};

const state = {
  toggleClass: false,
};

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
